import * as Yup from 'yup';

const schemaField = Yup.mixed().required('This field is required');

const itemSchema = Yup.object().shape({
  city: schemaField,
  endYear: Yup.mixed().when('present', (present, schema) => (
    present ? schema : schema.required('This field is required')
  )),
  endMonth: Yup.mixed()
    .when('present', (present, schema) => {
      return present ? schema :
        schema.required('This field is required')
          .test(
            'is-after-start',
            'End date must be after start date',
            function (currentValue) {
              if (!this.parent.endYear || !this.parent.startYear || !this.parent.startMonth) {
                return false;
              }

              if (this.parent.endYear.value < this.parent.startYear.value) {
                return false;
              }

              return !(this.parent.endYear.value === this.parent.startYear.value && currentValue.value < this.parent.startMonth.value);
            }
          );
    }),
  startYear: schemaField,
  startMonth: schemaField,
  industry: Yup.array().of(schemaField).min(1, 'This field is required').required('This field is required'),
  role: schemaField,
  position: schemaField,
  firm: schemaField,
});

export const stepFourSchema = Yup.object().shape({
  acceptedFullTime: Yup.boolean().nullable(true),
  flow: Yup.string().nullable(),
  items: Yup.array()
    .when('acceptedFullTime', (acceptedFullTime, schema) => (
      acceptedFullTime ? schema.of(itemSchema) : schema
    ))
    .when('flow', (flow, schema) => (
      flow === 'experienced-professional' ? schema.of(itemSchema) : schema
    )),
});

export const stepFourSchemaWithGroup = Yup.object().shape({
  acceptedFullTime: Yup.boolean().nullable(true),
  flow: Yup.string().nullable(),
  items: Yup.array()
    .when('acceptedFullTime', (acceptedFullTime, schema) => (
      acceptedFullTime ? schema.of(itemSchema.shape({
        group: Yup.array().of(schemaField).min(1, 'This field is required').required('This field is required'),
      })) : schema
    ))
    .when('flow', (flow, schema) => (
      flow === 'experienced-professional' ? schema.of(itemSchema.shape({
        group: Yup.array().of(schemaField).min(1, 'This field is required').required('This field is required'),
      })) : schema
    )),
});



